import { Link } from "react-router-dom";
import { StarRating } from "./StarRating";
import type { DiscoverApp } from "../services/discoverApps";

function PlaceholderStarRating() {
  return (
    <span aria-hidden="true" className="oac-app-card__rating-placeholder">
      {Array.from({ length: 5 }, (_, index) => (
        <svg
          aria-hidden="true"
          className="oac-app-card__star-placeholder"
          height="12"
          key={index}
          viewBox="0 0 24 24"
          width="12"
        >
          <path
            d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
            fill="#ececec"
          />
        </svg>
      ))}
    </span>
  );
}

export function DiscoverAppCardSkeleton() {
  return (
    <article aria-hidden="true" className="oac-app-card oac-app-card--placeholder">
      <span className="oac-app-card__icon-placeholder" />

      <div className="oac-app-card__title-group">
        <span className="oac-app-card__line oac-app-card__line--title" />
        <PlaceholderStarRating />
      </div>
    </article>
  );
}

type DiscoverAppCardProps = {
  app: DiscoverApp;
};

export function DiscoverAppCard({ app }: DiscoverAppCardProps) {
  const rating = app.average_rating ?? 0;
  const appPath = `/apps/${encodeURIComponent(app.slug)}`;

  if (!app.slug) {
    return null;
  }

  return (
    <Link
      className="oac-app-card oac-app-card--link"
      draggable={false}
      to={appPath}
    >
      {app.icon_url ? (
        <img
          alt=""
          className="oac-app-card__icon-placeholder oac-app-card__icon-img"
          draggable={false}
          src={app.icon_url}
        />
      ) : (
        <span aria-hidden="true" className="oac-app-card__icon-placeholder" />
      )}

      <div className="oac-app-card__title-group">
        <h2 className="oac-app-card__name">{app.name}</h2>
        <div className="oac-app-card__rating">
          <StarRating className="oac-app-card-stars" rating={rating} />
        </div>
      </div>
    </Link>
  );
}
